import { STANDARD_APP_MAX_WIDTH } from "@/css/constants";

export const SERVICE_DETAILS_VERTICAL_MARGIN = 48;
export const DESKTOP_SERVICE_DETAIL_WIDTH = [
  1,
  0.95,
  0.95,
  STANDARD_APP_MAX_WIDTH,
];

export const INT_TO_WORD: Record<number, string> = {
  1: "First",
  2: "Second",
  3: "Third",
  4: "Fourth",
  5: "Fifth",
  6: "Sixth",
  7: "Seventh",
  8: "Eighth",
  9: "Ninth",
  10: "Tenth",
};
